import React from 'react';
import PropTypes from 'prop-types';

class BackArrowIcon extends React.PureComponent {
	render() {
		const { width, height, fill } = this.props;

		const viewBox = [0, 0, width, height].join(' ');

		return (
			<svg width={width} height={height} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
				<title>Back Arrow Icon</title>
				<g fill={fill}>
					<path d="m.22377353 5.43956688 5.0558928-5.20924869c.144324-.1486983.3366801-.23031819.5417841-.23031819.2053316 0 .39757389.08173716.54189789.23031819l.45903682.473067c.14421018.14846377.22365667.34676726.22365667.55820499 0 .21132046-.07944649.41630834-.22365667.56477211l-2.94953631 3.04561801h9.37081607c.4225005 0 .7563351.34078649.7563351.77620983v.66879056c0 .43542334-.3338346.81056991-.7563351.81056991h-9.40427927l2.98288569 3.0626222c.14421018.1486983.22365667.3416074.22365667.5530451 0 .2112032-.07944649.4069267-.22365667.5555078l-.45903682.4715425c-.144324.1486983-.33656629.2297318-.54189787.2297318-.205104 0-.3974601-.082089-.5417841-.2307873l-5.0558928-5.20913139c-.1446655-.14916739-.2242258-.34829177-.2236567-.55996404-.0004552-.21237589.0789912-.41161754.2237705-.56055039z"/>
				</g>
			</svg>
		);
	}
}

BackArrowIcon.defaultProps = {
	width: 14,
	height: 12,
	fill: '#8A8B8C',
};

BackArrowIcon.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
	fill: PropTypes.string,
};

export default BackArrowIcon;



// WEBPACK FOOTER //
// ./src/components/shared/icons/backArrowIcon.js